import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  // NOTE: setupSelects is now called from here because 422 don't trigger any turbo events.
  // source: https://github.com/hotwired/turbo/issues/520
  connect () {
    window.setupSelects()
  }
}
